export const styles = () => ({
  root: {
    padding: 20,
    fontFamily: "Open Sans",
    fontStyle: "normal"
  },
  topContainer: {
    width: "100%",
    height: 113,
    padding: "20px 0px",
    display: "flex",
    alignItems: "center",
    justifyContent: "left",
    border: "1px solid #dadada",
    background: "white"
  },
  typeStyle: {
    fontSize: 16,
    lineHeight: "24px",
    padding: "0px 30px"
  },
  countSize: {
    fontSize: 32,
    lineHeight: "46px",
    fontWeight: 600
  },
  cardContainer: {
    textAlign: "center"
  },
  attendees: {
    fontSize: 20,
    lineHeight: "30px",
    fontWeight: 600,
    marginTop: 24,
    marginBottom: 12
  },
  tableHeader: {
    fontFamily: 'Open Sans',
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '20px',
    color: '#333333',
    position: "sticky",
    top: -1,
  },
  tableCell: {
    padding: '12px 16px',
    verticalAlign: 'middle'
  },
  eventTime: {
    fontFamily: 'Open Sans',
    fontSize: 12,
    lineHeight: '18px',
    color: 'rgba(51, 51, 51, 0.75)'
  },
  tableText: {
    fontSize: 14,
    lineHeight: '20px',
    textAlign: 'left',
    color: '#333333',
  },
  tableCellInvitee: {
    padding: '16px',
    verticalAlign: 'middle'
  },
  boldText: {
    fontWeight: 600
  },
  cellWidth: {
    width: 300
  },
  dropDown: {
    border: "1px solid #DADADA",
    width: 240
  },
  paperRoot: {
    top: "270px !important",
  },
  dropDownSelect: {
    color: "rgba(51, 51, 51, 0.5)",
    fontSize: 14,
    lineHeight: "20px",
    "&:before": {
      border: "none"
    }
  },
  boxStyles: {
    display: "flex",
    alignItems: "center",
    marginTop: 8
  },
  tableContainer: {
    maxHeight: "79vh",
    overflowY: "scroll"
  },
  tableContainerRoot: {
    borderTop: "0.5px solid #dadada",
    maxHeight: "79vh",
    overflowY: "auto",
    borderBottom: "0.5px solid #dadada",
  }
})